import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authAPI } from '../utils/api';
import './LoginPage.scss';

const ForgotPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      await authAPI.requestPasswordReset((email || '').trim().toLowerCase());
      setSuccess(t('forgotPassword.success'));
    } catch (err: any) {
      setError(err.response?.data?.error || t('forgotPassword.errors.requestFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__container">
        <button type="button" className="page-back" onClick={() => navigate('/login')} aria-label={t('nav.back')}>
          ← {t('nav.back')}
        </button>
        <header className="login-page__header">
          <h1 className="login-page__title">{t('forgotPassword.title')}</h1>
        </header>
        <p>{t('forgotPassword.subtitle')}</p>
        <form className="login-page__form" onSubmit={handleSubmit}>
          {error && <div className="form-error-message">{error}</div>}
          {success && <div className="form-success-message">{success}</div>}
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              {t('forgotPassword.form.email')}
            </label>
            <input
              id="email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? t('forgotPassword.form.loading') : t('forgotPassword.form.submit')}
          </button>
        </form>
        <p className="login-page__footer">
          <Link to="/login" className="link">
            {t('forgotPassword.backToLogin')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
